<template>
    <AccountModal v-model="sazkaAlertProps.isOpen" class="sazka-alert">
        <InfoText :title="sazkaAlertProps.title" :perex="sazkaAlertProps.text" class="sazka-alert__info"></InfoText>
        <div class="sazka-alert__buttons" v-if="sazkaAlertProps.ctaText">
            <button class="btn sazka-alert__button" :class="btnClass" @click="ctaClickHandler">
                {{ sazkaAlertProps.ctaText }}
            </button>
        </div>
    </AccountModal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import AccountModal from "@/account/components/shared/account-modal.vue";
import InfoText from "@/account/components/shared/info-text.vue";
import { sazkaAlertProps } from "../use-sazka-alert";

const btnClass = computed(() => (sazkaAlertProps.ctaYellow ? "btn-secondary" : "btn-primary"));

const ctaClickHandler = () => {
    if (sazkaAlertProps.ctaFunction) {
        sazkaAlertProps.ctaFunction();
    }

    sazkaAlertProps.isOpen = false;
};
</script>
